// Import components.
import Voting from './components/Voting.jsx';

/**
 * <pre>
 * Voting module React Components.
 *
 * Summary of responsibilities:
 *
 *  - defines React components that this app module can render
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Voting
 * @namespace
 *
 * @type {Object}
 */
const Components = {
	Voting: Voting
};

export default Components;